export default __webpack_public_path__ + "static/media/available_shift.08ac8899.svg";